import { Typography, Link } from "@mui/material";

const ErrorPage401 = () => {
  return (
    <div className="flex flex-col justify-center items-center text-center h-full">
      <Typography variant="h3">401 Unauthorized</Typography>
      <Typography variant="body1">
        Your session has expired. <Link href="/login">Please login again</Link>
        .
      </Typography>
    </div>
  );
};

export default ErrorPage401;
